<template>
  <div :class="$style.post">
    <div :class="$style.header">
      <Category :category="post.category" :class="$style.category" />
    </div>
    <div :class="$style.title">{{ post.title }}</div>
    <div :class="$style.subtitle">{{ post.subtitle }}</div>
    <p :class="$style.text">{{ post.text }}</p>
    <div :class="$style.bottom">
      <div>{{ formatTime(post.createdAt) }}</div>
      <div :class="$style.bottomRight">
        <div v-if="isShowViews" :class="$style.views">
          <BaseIcon name="eye" :class="$style.viewsIcon" />{{ post.views }}
        </div>
        <div
          :class="$style.action"
          @click.prevent="share"
        >
          <BaseIcon custom name="share" />
        </div>
        <div
          :class="$style.action"
          @click.prevent="toggleMark"
        >
          <BaseIcon v-if="!post.isMarked" :name="['far', 'bookmark']" />
          <BaseIcon v-else name="bookmark" :class="$style.marked" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Category from '@/components/Category'
import { formatDistanceStrict, format } from '@/utils/date'
import { isToday } from 'date-fns'
import { mapActions, mapGetters } from 'vuex'
import { AFFILIATE_BLOG_ID } from '@/utils/config'

export default {
  name: 'blog-post-list-item',
  components: {
    Category
  },
  props: {
    post: {
      type: Object,
      required: true
    }
    // blogId: {
    //   type: String,
    //   required: true
    // }
  },
  computed: {
    ...mapGetters({
      blogById: 'entities/blogs/getBlog' // 'entities/blogs/find'
    }),
    isShowViews () {
      return this.post.blog.shortId !== AFFILIATE_BLOG_ID && !this.post.blog.isService
    }
  },
  methods: {
    ...mapActions({
      mark: 'entities/posts/mark',
      unMark: 'entities/posts/unMark'
    }),
    formatTime (time) {
      const date = new Date(time)
      return isToday(date) ? formatDistanceStrict(date, new Date()) : format(date)
    },
    share () {
      const link = window.location.origin + this.$router.resolve({
        name: 'app-blogs-post',
        params: {
          blogId: this.post.blog.shortId,
          postId: this.post.uuid
        }
      }).href
      this.$modal.show('share-to-chat', {
        value: link,
        text: `${this.$t('blogLinkShareTxt')} ${this.post.blog.blogInfoDisplay.name}: ${link}`
      })
    },
    toggleMark () {
      if (!this.post.isMarked) {
        this.mark(this.post.uuid)
      } else {
        this.unMark(this.post.uuid)
      }
    }
  }
}
</script>

<style module lang="scss">
.post {
  padding: 10px;
  // border-bottom: 1px solid $border-color;
  > * {
    color: $text-darkest;
  }
}
.category {
  margin-bottom: 12px;
}
.title {
  text-transform: uppercase;
  font-size: 22px;
  font-weight: 500;
}
.text {
  color: $text-mid;
  margin-top: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  max-height: 100px;
}
// .icon {
//   width: 16px;
//   height: 16px;
//   background-size: 1100%;
//   background-position: center;
//   margin-right: 6px;
// }
.bottom {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
}
.bottomRight {
  display: flex;
  color: $text-mid;
  > * {
    margin-left: 15px;
  }
}
.views {
  color: $text-mid;
  &Icon {
    margin-right: 5px;
  }
}
.action {
  font-size: 20px;
  &:hover {
    color: $text-darkest;
  }
}
.marked {
  color: $text-colored;
}
</style>
